import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { TRoutes } from '../../shared/const'

import styles from './style.module.scss'

/**
 * „Powered by DaVinciLab" in beiden Fußzeilen.
 *
 * Bis 25.08.2026 ein Verweis auf davincilab.at, danach kurz ein Fenster mit
 * einem Steckbrief — seit 26.08.2026 führt er auf die Seite `/davincilab`.
 *
 * Warum kein Fenster mehr: Die Seite soll einer
 * Junior-Achievement-Organisation in einem anderen Land zeigen, was hier
 * läuft. **Ein Fenster hat keine Adresse** — was begeistern soll, muss man
 * verschicken können. Außerdem passte der Inhalt nicht mehr hinein: Bilder,
 * Aufschlüsselungen und hochlaufende Kennzahlen brauchen mehr Platz als ein
 * Dialog in der Fußzeile.
 *
 * Ein `Link` und kein `<a>` nach draußen: Der Weg zu davincilab.at steht auf
 * der Seite selbst, an zweiter Stelle.
 *
 * Das Aussehen bleibt Sache der Fußzeile — die helle Leiste im angemeldeten
 * Bereich und die dunkle der öffentlichen Seiten setzen `className` selbst.
 */
export default function PoweredBy({ className }) {
	return (
		<Link to={TRoutes.PUBLIC_DAVINCILAB} className={clsx(styles.verweis, className)}>
			Powered by DaVinciLab
		</Link>
	)
}

PoweredBy.propTypes = {
	/** Die Klasse der jeweiligen Fußzeile — sie bestimmt Farbe und Größe. */
	className: PropTypes.string
}
